<template>
  <modal transition="pop-out" name="new-category" :width="550" :height="500">
    <div class="w-full">
      <div class="h-10 w-full border-b border-gray-200">
        <p class="px-8 py-2 text-gray-700 font-bold">Create new category</p>
      </div>
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4 mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <el-input placeholder="e.g Granola Pack" v-model="form.name"></el-input>
          <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Description
          </label>
          <el-input placeholder="Description..." v-model="form.description" type="textarea"></el-input>
          <p v-if="errors.includes('description')" class="text-red-500 text-xs italic">Please provide some description.</p>
        </div>
        <div class="mb-4" v-if="false">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Tags
          </label>
          <el-select
            class="w-full"
            v-model="form.meta_tags"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="Choose tags for your article">
          </el-select>
        </div>
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Show On Homepage
          </label>
          <el-switch v-model="form.homepage_feature"></el-switch>
          <p v-if="false" class="text-red-500 text-xs italic">Please fill all fields.</p>
          <p v-if="homepageFeatureCountError" class="text-red-500 text-xs italic ">You can only have 3 Homepage Categories</p>
        </div>
        <div class="mb-10">
          <el-tag
            class="mr-1"
            :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            :class="{'ml-1':dynamicTags.length > 0}"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="mini"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" :class="{'ml-1':dynamicTags.length > 0}" size="small" @click="showInput">+ New Tag</el-button>
        </div>
        <div class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="creating">Create</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'NewCategoryForm',
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      creating: false,
      errors: [],
      homepageFeatureCountError: false,
      form: {
        name: '',
        description: '',
        homepage_feature: false,
      },
    };
  },
  methods: {
    async submit() {
      this.errors = [];

      // formValidation is a mixin in
      // src/Common/mixins/index.js
      this.errors = this.formValidation(this.form);

      // check for error length
      if (this.errors.length === 0 && !this.homepageFeatureCountError) {
        try {
          this.creating = true;

          this.form.meta_data = this.dynamicTags.join(',');

          const response = await this.$store.dispatch('InventoryModule/Catalog/createCategory', this.form);
          this.$modal.hide('new-category');
          this.$notify.warning({
            title: 'Success',
            message: 'Category Created, now add an image.',
          });

          // Display image upload modal
          this.$emit('imageUpload', response.id);
        } catch (e) {
          this.creating = false;
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }

        this.creating = false;
      }
    },
    handleClose(tag) {
      this.form.meta_data.splice(this.form.meta_data.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      if (this.inputValue) {
        this.dynamicTags.push(this.inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
  },
  watch: {
    'form.homepage_feature': function (val, oldVal) {
      if (!oldVal && val) {
        // Check for Homepage Count
        this.homepageFeatureCountError = this.$store.getters['InventoryModule/Catalog/getHomePageFeatureCount'];
      }

      if (oldVal && !val) {
        this.homepageFeatureCountError = false;
      }
    },
  },
};
</script>

<style scoped>
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    vertical-align: bottom;
  }
</style>
